var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.decisionMade)?_c('span'):_c('Control')}
var staticRenderFns = []

export { render, staticRenderFns }